import { createTypes, createAction } from 'lib/action'
const LOAD_STOCK_BALANCE = createTypes('loadstockbalance', 'load')
const LOAD_STOCK_BALANCE_DETAIL = createTypes('loadstockbalancedetail', 'load')
const EXPORT_STOCKE_BALANCE = createTypes('exportstockbalance', 'export')
const CREAT_STOCK_BALANCE = createTypes('createstockbalane', 'create')
const UPDATE_STOCK_BALANCE = createTypes('updatestockbalane', 'update')

const LOAD_STOCK_BALANCE_IS_DIRTY = createTypes('loadstockbalanceisdirty', 'load')
const LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY = createTypes('loadstockbalancedetailisdirty', 'load')
const CREAT_STOCK_BALANCE_FROM_IS_DIRTY = createTypes('createstockbalaneisdirty', 'create')
const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
    return {
      type: REMOVE_LISTS,
    }
}

const loadStockBalance = {
    request: (data, loading) =>
      createAction(LOAD_STOCK_BALANCE.REQUEST, { data, loading }),
    success: (lists, page) =>
      createAction(LOAD_STOCK_BALANCE.SUCCESS, { lists, page }),
    failure: () => createAction(LOAD_STOCK_BALANCE.FAITLURE),
}

const loadStockBalanceIsDirty = {
  request: (data, stock_balance_is_dirty_loading) =>
    createAction(LOAD_STOCK_BALANCE_IS_DIRTY.REQUEST, { data, stock_balance_is_dirty_loading }),
  success: (stock_balance_is_dirty_lists, page) =>
    createAction(LOAD_STOCK_BALANCE_IS_DIRTY.SUCCESS, { stock_balance_is_dirty_lists, page }),
  failure: () => createAction(LOAD_STOCK_BALANCE_IS_DIRTY.FAITLURE),
}

const loadStockBalanceDetail = {
  request: (data, loading) =>
    createAction(LOAD_STOCK_BALANCE_DETAIL.REQUEST, { data, loading }),
  success: lists =>
    createAction(LOAD_STOCK_BALANCE_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(LOAD_STOCK_BALANCE_DETAIL.FAITLURE),
}

const loadStockBalanceDetailIsDirty = {
  request: (data, loading) =>
    createAction(LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.REQUEST, { data, loading }),
  success: lists =>
    createAction(LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.SUCCESS, { lists }),
  failure: () => createAction(LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.FAITLURE),
}

const exportStockBalance = {
    request: (data, loading) =>
      createAction(EXPORT_STOCKE_BALANCE.REQUEST, { data, loading }),
    success: (lists, page) => createAction(EXPORT_STOCKE_BALANCE.SUCCESS, { lists }),
    failure: () => createAction(EXPORT_STOCKE_BALANCE.FAITLURE),
  }

const createStockBalance = {
    request: (data, loading) =>
      createAction(CREAT_STOCK_BALANCE.REQUEST, { data, loading }),
    success: res => createAction(CREAT_STOCK_BALANCE.SUCCESS, { res }),
    failure: () => createAction(CREAT_STOCK_BALANCE.FAITLURE),
}

const createStockBalanceFromIsDirty = {
  request: (data, loading) =>
    createAction(CREAT_STOCK_BALANCE_FROM_IS_DIRTY.REQUEST, { data, loading }),
  success: res => createAction(CREAT_STOCK_BALANCE_FROM_IS_DIRTY.SUCCESS, { res }),
  failure: () => createAction(CREAT_STOCK_BALANCE_FROM_IS_DIRTY.FAITLURE),
}

const updateStockBalance = {
  request: (data, loading) =>
    createAction(UPDATE_STOCK_BALANCE.REQUEST, { data, loading }),
  success: res => createAction(UPDATE_STOCK_BALANCE.SUCCESS, { res }),
  failure: () => createAction(UPDATE_STOCK_BALANCE.FAITLURE),
}


export {
    LOAD_STOCK_BALANCE,
    loadStockBalance,
    LOAD_STOCK_BALANCE_DETAIL,
    loadStockBalanceDetail,
    EXPORT_STOCKE_BALANCE,
    exportStockBalance,
    CREAT_STOCK_BALANCE,
    createStockBalance,
    UPDATE_STOCK_BALANCE,
    updateStockBalance,
    REMOVE_LISTS,
    loadStockBalanceIsDirty,
    LOAD_STOCK_BALANCE_IS_DIRTY,
    loadStockBalanceDetailIsDirty,
    LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY,
    createStockBalanceFromIsDirty,
    CREAT_STOCK_BALANCE_FROM_IS_DIRTY,
    removeLists,
}
  